import { useRoute, useRouter } from '#imports'
import { type Ref, onMounted } from 'vue'

import { productAPI } from '@backmarket/http-api'
import { parse } from '@backmarket/utils/query-string/parse'
import { stringify } from '@backmarket/utils/query-string/stringify'

import { useUrlParams } from './useUrlParams'

/**
 * The product pages relies on the URL to know its current state, including the currently selected grade, which lies
 * in the URL hash (i.e.: #l=10).
 *
 * When the page is accessed without any hash, we add the grade based on the default selected grade for the product. This happens quite
 * often from linking in our app or by SEO access.
 */
export const useAddGradeInUrl = (
  currentGrade: Ref<
    productAPI.GetBestOffersResponse[number] | null | undefined
  >,
) => {
  const { grade } = useUrlParams()
  const router = useRouter()
  const route = useRoute()

  onMounted(() => {
    if (grade.value || !currentGrade.value) {
      return
    }

    void router.replace({
      ...route,
      hash: `#${stringify({
        ...parse(route.hash),
        l: currentGrade.value?.backboxGrade.value,
      })}`,
    })
  })
}
